import Axios from 'api/axios'
import { TextProcessorApi, TextProcessorApiFactory, type TextProcessorPatternDto } from 'api/swagger/definitions/backoffice'
import config from 'config'
import type { TextProcessorPattern, TextProcessorPatternPatch } from './types'

const textProcessorApi = TextProcessorApiFactory(undefined, config.boBaseUrl, Axios)

export const getAllTextProcessors = async () =>
  textProcessorApi.getAllTextProcessorConfigurations().then(({ data }) => mapTextProcessorPatterns(data))

export const deleteTextProcessor = async (id: string) => textProcessorApi.deleteTextProcessorConfiguration(id)

export const patchTextProcessor = async (id: string, patch: TextProcessorPatternPatch) =>
  textProcessorApi.updateTextProcessorConfiguration(id, patch).then(({ data }) => mapTextProcessorPatterns([data]))

const mapTextProcessorPatterns = (patterns: TextProcessorPatternDto[]): TextProcessorPattern[] =>
  patterns.map((pattern: TextProcessorPatternDto) => ({
    id: pattern.id,
    pattern: pattern.pattern,
    matchText: pattern.matchText ?? '',
    isActive: pattern.isActive,
  }))
